module.exports = __webpack_public_path__ + "img/core_02.b268b251.png";